import { useNavigator } from '@repo/toolkit/use-navigator'
import { ActivityIcon, PlusIcon } from '@repo/ui/icons'
import { useRef } from 'react'

import { API, constructApiUrl } from '../../../api/apis.config'
import DynamicDataTable, { DynamicTableRef } from '../../../components/elements/dynamic-table'
import LoadingScreen from '../../../components/elements/loading/loading-screen'
import UserNavBar from '../../../components/elements/nav-bar'
import { Paths } from '../../../lib/constants/path'
import useAuth from '../../../lib/hooks/use-auth'
import useTranslate from '../../../lib/hooks/use-translate'
import { Activity } from '../../../lib/types/models/ol/activity/activity'
import { isHostFamilyDayActivity } from '../../../utils/constants/activity.constants'
import { getActivityColumns } from './util'

const ActivitiesListPage = () => {
  const { navigate, navigateWithEvent } = useNavigator()
  const tableRef = useRef<DynamicTableRef<Activity>>(null)
  const { user } = useAuth()
  const { t } = useTranslate()
  const ol = user?.ol

  if (!ol) return <LoadingScreen />

  return (
    <div>
      <UserNavBar title={'Activities'} icon={ActivityIcon} />
      <div className={'h-4'} />
      <DynamicDataTable<Activity, null>
        ref={tableRef}
        title={'Activities'}
        deleteMessage={{
          attributeName: 'name',
          name: 'activity',
          deleteMany: 'Are you sure you want to delete the selected activities?',
          deleteOne: 'Are you sure you want to delete this activity?',
          deleteAll: 'Are you sure you want to delete all the activities?'
        }}
        columns={getActivityColumns(t, ol.currency)}
        selectable
        allowSearchParam
        // "Host family day" is a default activity: it cannot be opened, selected or deleted
        disableRow={isHostFamilyDayActivity}
        permissions={{
          delete: true,
          disableDelete: (activities) => activities.some(isHostFamilyDayActivity)
        }}
        onRowClick={(activity, event) => {
          if (isHostFamilyDayActivity(activity)) return
          navigateWithEvent(
            Paths.OL_PERSONAL_SPACE_ACTIVITY_UPDATE_PAGE.replace(':id', activity.id.toString()),
            event
          )
        }}
        endpoint={constructApiUrl(API.ols.getActivities.url, { olId: ol.id })}
        actions={[
          {
            type: 'global',
            icon: PlusIcon,
            variant: 'primary',
            label: 'Add activity',
            fn: () => navigate(Paths.OL_PERSONAL_SPACE_ACTIVITY_CREATE_PAGE)
          }
        ]}
      />
    </div>
  )
}

export default ActivitiesListPage
